<template>
	<div>
		<h3>Info on the project coming soon!</h3>
	</div>
</template>

<script>
export default {
  name: 'Info',
}
</script>

<style scoped>
</style>
